// Shared light-surface card class (the global ui/card is a dark glass surface
// built for auth screens — reuse the inventory light styling here).
export const LIGHT_CARD =
  "rounded-xl border border-slate-200 bg-white shadow-none backdrop-blur-none"

export const STATUSES = [
  { value: "draft", label: "Draft", badge: "bg-slate-100 text-slate-600" },
  { value: "live", label: "Live", badge: "bg-emerald-100 text-emerald-800" },
  { value: "archived", label: "Archived", badge: "bg-slate-100 text-slate-500" },
]

export const STATUS_MAP = Object.fromEntries(STATUSES.map((s) => [s.value, s]))

// Informational label for which manager the leads route to. The actual target
// is the chosen assignee (membership); this just records intent.
export const MANAGER_ROLES = [
  { value: "", label: "—" },
  { value: "site_head", label: "Site head" },
  { value: "team_lead", label: "Team lead" },
  { value: "sourcing_manager", label: "Sourcing manager" },
  { value: "closing_manager", label: "Closing manager" },
  { value: "sales_executive", label: "Sales executive" },
]

export const MANAGER_ROLE_MAP = Object.fromEntries(
  MANAGER_ROLES.map((r) => [r.value, r.label])
)
